import { InsightsOrderByColumns } from "../hooks/useInsightsData";

export const InsightsPeriodTabs = [
  {
    translationKey: "todayString",
    key: "today",
  },
  {
    translationKey: "yesterdayString",
    key: "yesterday",
  },
  {
    translationKey: "last7DaysString",
    key: "last7days",
  },
  {
    translationKey: "last4WeeksString",
    key: "last4weeks",
  },
];

export const defaultInsightsOrderByValues: InsightsOrderByColumns = {
  articleInsights: {
    column: "estimatedTurnover",
    direction: "desc",
  },
  refilledAreaInsights: {
    column: "estimatedTurnover",
    direction: "desc",
  },
  refilledSalesLocationIDInsights: {
    column: "estimatedTurnover",
    direction: "desc",
  },
  itemHfbTypeInsights: {
    column: "estimatedTurnover",
    direction: "desc",
  },
};
